var neverEverList = function () {

    // Selectors object
    var selectors = {
    };
    
    // Local function name - not available outside this object
    var listeners = function (){
        MicroModal.init({
            onShow: function () {
                document.body.classList.add('no--scroll');
            },
            onClose: function() {
                document.body.classList.remove('no--scroll');
            }
        });
        
    };

    listeners();

}();